import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { IConnectedApplicationType } from '../types/ConnectedApplicationType';
import { API_VERSION, DIRECT_TRUST_PATH } from './RestApiConstants';

export interface IGetConnectedApplicationResult extends IResult {
    connectedApplication: IConnectedApplicationType;
}

function getConnectedApplicationRequestConfig(id: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: `${API_VERSION}`,
    httpMethod: 'GET',
    endpoint: `${DIRECT_TRUST_PATH}/${id}`,
    serverWideRequest: false
  };
}

export function callGetConnectedApplication(id: string): Promise<IGetConnectedApplicationResult> {
  return makeJsonRestApiRequest<void, IGetConnectedApplicationResult>({
    config: getConnectedApplicationRequestConfig(id),
    request: null,
  });
}